const endTripEvents = [
  'ManualDispatchTermination',
  'DispatchCompletedByDispatcher',
  'EndOfTrip'
];

const equipmentUpdateEvents = [
  'UpdateDolly',
  'AddDolly',
  'UpdateTractor',
  'AddTractor',
  'AddTrailer'
];

const voidUnvoidEvents = ['VoidPickup', 'UnvoidPickup'];

export { endTripEvents, equipmentUpdateEvents, voidUnvoidEvents };
